export abstract class AuthProvider {
    abstract getUserName(): string;
    abstract getDisplayName(): string;
    abstract getAuthToken(): string;
}